var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFooterFixedMedium = function SvgIconFooterFixedMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-footer-fixed-Medium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M9 8c0 2.344-1.794 4.25-4 4.25S1 10.344 1 8s1.794-4.25 4-4.25S9 5.656 9 8m6.5-4a.5.5 0 0 0-.5.5s-.25.831-.25 3.5.25 3.5.25 3.5a.5.5 0 0 0 1 0s.25-.831.25-3.5S16 4.5 16 4.5a.5.5 0 0 0-.5-.5M12 4c-.356 0-1.025.175-1.519 1.331C10.17 6.05 10 7 10 8s.169 1.95.481 2.669C10.975 11.825 11.644 12 12 12s1.025-.175 1.519-1.331C13.83 9.95 14 9 14 8s-.169-1.95-.481-2.669C13.025 4.175 12.356 4 12 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-footer-fixed-Medium_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgIconFooterFixedMedium;